import { DateRangeFilter, FiltersCollection, SortingModel } from '@libs/store/filters';
import dayjs from 'dayjs';
import { TIMEZONE_FALLBACK } from '../../config';

type filterToQueryParamsOptions = {
  removeEmpty?: boolean;
  renameMap?: Record<string, string>;
};
export function filterToQueryParams(
  filters?: FiltersCollection,
  { removeEmpty, renameMap }: filterToQueryParamsOptions = {},
) {
  return Object.keys(filters || {}).reduce<
    Record<string, string[] | string | number | { dateTime: string; timeZone: string }>
  >((acc, filterKey) => {
    const filterValue = (filters || {})[filterKey].value;
    const filterRenamed = renameMap?.[filterKey] ?? filterKey;
    if (filterKey === 'startDate' && typeof filterValue === 'object' && !Array.isArray(filterValue)) {
      const dateRangeFilterValue = filterValue as unknown as DateRangeFilter['value'];
      return {
        ...acc,
        ...(dateRangeFilterValue.from && {
          [renameMap?.[`startDate`] ? renameMap?.[`startDate`] : `startDate`]: dayjs(dateRangeFilterValue.from)
            .startOf('day')
            .format('YYYY-MM-DDTHH:mm:ss.sss'),
        }),
        ...(dateRangeFilterValue.to && {
          [renameMap?.[`endDate`] ? renameMap?.[`endDate`] : `endDate`]: dayjs(dateRangeFilterValue.to)
            .startOf('day')
            .format('YYYY-MM-DDTHH:mm:ss.sss'),
        }),
        [`timeZone`]: dateRangeFilterValue.timezone || TIMEZONE_FALLBACK,
      };
    }
    // Legacy next TODO - remove once be sure that it's not used
    if (typeof filterValue === 'object' && !Array.isArray(filterValue)) {
      const dateRangeFilterValue = filterValue as unknown as DateRangeFilter['value'];
      return {
        ...acc,
        [`${filterRenamed}_from`]: [
          dateRangeFilterValue.from ? dayjs(dateRangeFilterValue.from).startOf('day').toDate().toISOString() : '',
        ],
        [`${filterRenamed}_to`]: [
          dateRangeFilterValue.to ? dayjs(dateRangeFilterValue.to).startOf('day').toDate().toISOString() : '',
        ],
      };
    }
    if (Array.isArray(filterValue) && filterValue.length === 0 && removeEmpty) {
      return { ...acc };
    }
    if (typeof filterValue === 'string' && (filterValue as string).length === 0 && removeEmpty) {
      return { ...acc };
    }
    if (typeof filterValue === 'string') {
      return { ...acc, [`${filterRenamed}`]: filterValue };
    }
    return { ...acc, [`${filterRenamed}_in`]: filterValue };
  }, {});
}

type transformSortingOptions = {
  renameMap?: Record<string, string>;
};
export function transformSorting(model?: SortingModel, { renameMap }: transformSortingOptions = {}) {
  return (model || []).map((p) => {
    const renamedField = renameMap?.[p.field] ?? p.field;
    return `${renamedField}_${p.sort}`;
  });
}
